import moment from 'moment-timezone'

import { getExpectedProgress, getRemainingOperationalDays, TargetProgress } from './GoalProgress'
import { formatTargetPhasePosition } from './goalPhases'

const ProcastGoalsPanel = ({ goals, visible }) => {
    const timezone = localStorage.getItem('timezone') || moment.tz.guess()

    return (
        <div className={`procast-goals-panel ${visible ? 'TickerIn' : 'TickerOut'}`}>
            <div className="Label procast-goals-title">KPI GOALS</div>
            <div className="procast-goals-list">
                {goals.map((goal) => {
                    const period = goal.progress.current
                    const expectedPercentage = getExpectedProgress(period, timezone)
                    const remainingDays = getRemainingOperationalDays(period, timezone)

                    return (
                        <section className="procast-goal" key={goal._id}>
                            <div className="procast-goal-heading">
                                <div className="procast-goal-name">
                                    <strong>{goal.name}</strong>
                                    {period.targetPhase && <small>{formatTargetPhasePosition(period.targetPhase)}</small>}
                                </div>
                                <span>{Math.round(period.overallPercentage || 0)}%</span>
                            </div>
                            {(period.targetProgress || []).map((target) => (
                                <TargetProgress
                                    compact
                                    key={target.id}
                                    target={target}
                                    questions={goal.questions}
                                    expectedPercentage={expectedPercentage}
                                    remainingDays={remainingDays}
                                />
                            ))}
                        </section>
                    )
                })}
            </div>
        </div>
    )
}

export default ProcastGoalsPanel
